/** Ответ на PIN: UUID запроса входа; одинаков по форме для любого исхода */
export class PinRequest {
  request: string

  constructor({ request }: { request: string }) {
    this.request = request
  }
}
